export var BannerType;
(function (BannerType) {
    BannerType["Share"] = "share";
    BannerType["AutomatedCampaign"] = "automated-campaign";
})(BannerType || (BannerType = {}));
